import { render } from "./CourseCenter.vue?vue&type=template&id=e51407f0&scoped=true"
import script from "./CourseCenter.vue?vue&type=script&lang=js"
export * from "./CourseCenter.vue?vue&type=script&lang=js"

import "./CourseCenter.vue?vue&type=style&index=0&id=e51407f0&lang=scss&scoped=true"
import "./CourseCenter.vue?vue&type=style&index=1&id=e51407f0&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e51407f0"]])

export default __exports__